import { Dispatch } from 'react';

export interface ISmartForm {
  id: number;
  enabled: boolean;
  title: string;
  updated_at: string;
  created_at: string;
  created_by: string;
  entity_id: number;
  deletable: boolean;
}

export interface ISmartFormsTableProps {
  forms: ISmartForm[];
  loadingForms: boolean;
  density: string;
  totalPages: number;
  totalForms: number;
  SmartFormsState: SmartFormsState;
  dispatch: Dispatch<SmartFormsAction>;
  refetchForms: () => void;
}

export interface IEntity {
  name: string;
  id: number;
}
export interface IError {
  errors: string[];
}

export interface IForm {
  id: number;
  name: string;
  enabled: boolean;
  entity_id: number;
  fields: IField[];
}

export interface IField {
  id: number;
  enabled: boolean;
  required: boolean;
  position: number;
  title: string;
  type: string;
  field_type: string;
  weight: number;
  rateable: boolean;
  field_choices: IFieldChoices[];
}

export interface IFieldChoices {
  id: number;
  name: string;
  position: number;
  rating: number;
  rank: number;
  rank_value: number;
}

export enum ModalType {
  CREATE = 'create',
  UPDATE = 'update',
  CLONE = 'clone',
  CLONE_WITHOUT_FORM = 'clone_without_form'
}

export interface SmartFormsState {
  currentPage: number;
  rowsPerPage: number;
  sortBy: string;
  sortOrder: string;
  search: string;
  snackbar: {
    message: string;
    state: 'success' | 'warning' | 'error';
  };
  isDialogOpen: boolean;
  deleteSmartForm: number;
  showSmartFormModal: ModalType | null;
  enabled: boolean;
  selectedEntity: number;
  name: string;
  selectedForm: ISmartForm | null;
}

export type SmartFormsAction =
  | { type: 'SET_CURRENT_PAGE'; payload: number }
  | { type: 'SET_ROWS_PER_PAGE'; payload: number }
  | { type: 'SET_SORT_BY'; payload: string }
  | { type: 'SET_SORT_ORDER'; payload: string }
  | { type: 'SET_SEARCH'; payload: string }
  | { type: 'SET_SNACKBAR'; payload: { message: string; state: 'success' | 'warning' | 'error' } }
  | { type: 'SET_IS_DIALOG_OPEN'; payload: boolean }
  | { type: 'SET_DELETE_SMART_FORM'; payload: number }
  | { type: 'SET_MODAL_OPEN'; payload: ModalType | null }
  | { type: 'SET_TOGGLE_ENABLED' }
  | { type: 'SET_SELECTED_ENTITY'; payload: number }
  | { type: 'SET_NAME'; payload: string }
  | { type: 'RESET_SMART_FORM' }
  | { type: 'SET_SELECTED_FORM'; payload: ISmartForm };

